import React from "react";
import "./AbasBlog.css";

const AbasBlog = ({ abaAtiva, setAbaAtiva }) => {
  const abas = ["HOME", "RECEITAS", "GUIAS", "DICAS", "CORTES DE CARNE"];

  return (
    <div className="abas-blog">
      <ul className="abas-lista">
        {abas.map((aba) => (
          <li
            key={aba}
            className={`aba-item ${abaAtiva === aba ? "ativa" : ""}`}
            onClick={() => setAbaAtiva(aba)}
          >
            {aba}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AbasBlog;
